import React, { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Money, Badge, statusTone } from "@/components/common";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/my/orders").then(({ data }) => setOrders(data)); }, []);
  return (
    <div data-testid="orders-page">
      <PageHeader title="Purchase History" subtitle="All your orders and invoices" />
      {orders.length === 0 ? <EmptyState icon={ShoppingBag} title="No orders yet" /> : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-white border border-border rounded-lg p-5" data-testid={`order-${o.id}`}>
              <div className="flex items-center justify-between">
                <div><span className="font-heading font-bold text-navy">#{o.order_no}</span><span className="text-xs text-muted-foreground ml-3">{new Date(o.created_at).toLocaleDateString()}</span></div>
                <Badge tone={statusTone(o.status)}>{o.status}</Badge>
              </div>
              <div className="mt-3 space-y-1">
                {o.items.map((it, i) => (
                  <div key={i} className="flex justify-between text-sm"><span>{it.title} {it.qty > 1 && `× ${it.qty}`}</span><Money amount={it.price * (it.qty || 1)} /></div>
                ))}
              </div>
              <div className="flex justify-between border-t border-border mt-3 pt-3 font-semibold"><span>Total</span><Money amount={o.total} /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
